<template>
  <b-card no-body>
    <b-card-body>
      <b-row class="d-flex align-items-center">
        <b-col>
          <h3>Kritik Bilgiler</h3>
        </b-col>
        <b-col>
          <div class="text-right">
            <b-button
              variant="primary"
              :to="$route.path + '/files/add-secret'"
            >
              <FeatherIcon icon="PlusIcon" /> Oluştur
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      :busy="loading"
      :empty-text="emptyText"
      :show-empty="!!emptyText"
    >
      <template #cell(title)="data">
        {{ data.item.title }}
        <b-badge
          v-if="data.item.CurrentVersion.version"
          variant="light-info"
          class="mr-1"
        >
          {{ data.item.CurrentVersion.version }}
        </b-badge>
        <div class="mt-1">
          <b-badge
            v-if="data.item.document_groups"
            variant="light-primary"
            class="mr-1"
          >
            <feather-icon icon="FolderIcon" />
            {{ data.item.document_groups }}
          </b-badge>
          <template v-if=" data.item.CurrentVersion.status === 'draft'">
            <b-badge
              variant="light-secondary"
              class="mr-1"
            >
              Taslak
            </b-badge>
          </template>
          <template v-if=" data.item.CurrentVersion.status === 'alpha'">
            <b-badge
              variant="light-warning"
              class="mr-1"
            >
              Test / Alpha
            </b-badge>
          </template>
          <template v-if=" data.item.CurrentVersion.status === 'released'">
            <b-badge
              variant="light-success"
              class="mr-1"
            >
              Yayınlanmış/Kararlı
            </b-badge>
          </template>
          <template v-if=" data.item.CurrentVersion.status === 'deprecated'">

            <b-badge
              variant="light-danger"
              class="mr-1"
            >
              Kullanımdan Kaldırılmış/Eski
            </b-badge>
          </template>
        </div>
      </template>
      <template #cell(username)="data">
        {{ data.item.username }}
        <div v-if="data.item.created">
          <small class="text-primary">
            <feather-icon icon="SaveIcon" />
            {{ moment(data.item.created).format('DD.MM.YYYY HH:mm:ss') }}
          </small>
        </div>
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <list-buttons
            :edit-action="$route.path + '/files/edit/' + data.item.id"
            :delete-action="removeData"
            :data-id="data.item.id"
          />
          <download-file
            file-component="services"
            :file-id="Number(data.item.id)"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-if="dataCounts > perPage"
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BBadge, BRow,
  BCol,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import DownloadFile from '@/layouts/components/DownloadFile.vue'

const tableName = 'service_files'
export default {
  name: 'ServicesSecretFilesCard',
  components: {
    DownloadFile,
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    ListButtons,
    BBadge,
    BRow,
    BCol,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'title',
          label: 'Başlık',
        },
        {
          key: 'username',
          label: 'Ekleyen',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          `${tableName}.created AS created`,
          'document_groups.title AS document_groups',
          'users.name AS username',
        ],
        where: {
          'service_files.is_secret': 1,
          'service_files.id_services': this.$route.params.id,
        },
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    loading() {
      return this.$store.getters['serviceFiles/loading']
    },
    emptyText() {
      if (this.loading === true) {
        return 'Lütfen bekleyiniz...'
      }
      if (this.dataList.length === 0) {
        return 'İçerik bulunamadı.'
      }
      return null
    },
    dataList() {
      return this.$store.getters['serviceFiles/secretDataList']
    },
    dataCounts() {
      return this.$store.getters['serviceFiles/dataSecretCounts']
    },
    saveData() {
      return this.$store.getters['serviceFiles/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.getDataList()
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.dataQuery.where['service_files.id_services'] = this.$route.params.id
      this.$store.dispatch('serviceFiles/getDataSecretList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('serviceFiles/removeData', id)
            .then(response => {
              if (response.status) {
                this.$swal({
                  icon: 'success',
                  title: this.$store.state.app.removeResultTitle,
                  text: this.$store.state.app.removeResultMessage,
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              } else {
                this.$swal({
                  icon: 'error',
                  title: 'İşlem Uyarısı!',
                  text: response.message,
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-danger',
                  },
                })
              }
            })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
